module.exports = __webpack_public_path__ + "media/dashboard/assets/images/menu-icons/subscription-2e3104b5ac2df39a09d4fc57431d6eeb.png";